import pull from "lodash/pull";
import countriesList from "country-list";

const countries = countriesList();

const Location = async ({ api, session, locals }, next) => {
  try {
    const location =
      session.get("location") || (await (await api("geoip")).json());
    locals.location = location;
    session.set("location", location);
    const { country } = location;
    locals.countries = [country].concat(pull(countries.getCodes(), country));
  } catch (e) {
    locals.location = {
      city: "Calgary",
      country: "CA",
      region: "AB",
    };
    session.set("location", locals.location);
    locals.countries = countries.getCodes();
  }

  locals.getCountryName = countries.getName;
  locals.getCountryCode = countries.getCode;
  await next();
};

export default Location;
